export default "__VITE_ASSET__BH8aNMhI__";